module.exports = __webpack_public_path__ + "img/bx-lesson-nickname.9ed7c990.svg";